import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdateNeuropsychologicDiagnosticPrescriptionMutation as useChUpdateNeuropsychologicDiagnosticPrescriptionMutationType } from "@/modules/patients/detail/neuropsychologic-diagnostic-prescription/ch/services/__generated__/useChUpdateNeuropsychologicDiagnosticPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChUpdateNeuropsychologicDiagnosticPrescriptionMutation(
    $input: Ch_updateNeuropsychologicDiagnosticPrescriptionInput!
  ) {
    ch_updateNeuropsychologicDiagnosticPrescription(input: $input) {
      ch_NeuropsychologicDiagnosticPrescription {
        id
        ...chNeuropsychologicDiagnosticPrescriptionDrawerFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdateNeuropsychologicDiagnosticPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdateNeuropsychologicDiagnosticPrescriptionMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdateNeuropsychologicDiagnosticPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdateNeuropsychologicDiagnosticPrescriptionMutation }
